import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@rebass/emotion';

import GenericError, {
  GenericErrorTitle,
  GenericErrorMessage,
} from '@app/components/GenericError/GenericError';

import { Button } from '@app/shop/components/Button';
import { APP_BASE_URL } from '@config/common.config';
import messages from './NotFound.messages';
import Status from '../Status';

const NotFound: FC = () => (
  <Status code={404}>
    <Box my={[4, 5]} px={[3, 0]} data-testid="not-found">
      <GenericError showSupport={false}>
        <GenericErrorTitle>
          <FormattedMessage {...messages.headline} />
        </GenericErrorTitle>
        <GenericErrorMessage>
          <FormattedMessage {...messages.message} />
        </GenericErrorMessage>
        <a href={APP_BASE_URL}>
          <Button type="primary">
            <FormattedMessage {...messages.homepage} />
          </Button>
        </a>
      </GenericError>
    </Box>
  </Status>
);

export default NotFound;
